// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file driver_on_shift_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverIncidentType, DriverIncidentTypeJson } from "./driver_incident_pb";
import { file_driver_incident } from "./driver_incident_pb";
import type { DriverOnShiftCreateSchema, DriverOnShiftListSchema, DriverOnShiftRequestSchema, DriverOnShiftSchema, DriverOnShiftUpdateSchema, TruckDriverOnShiftListRequestSchema, TruckDriverOnShiftListSchema } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { DriverOnShiftStatus, DriverOnShiftStatusJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file driver_on_shift_service.proto.
 */
export const file_driver_on_shift_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_driver_incident, file_driver_on_shift, file_enums, file_general]);

/**
 * @generated from message raccoonai.DriverOnShiftListRequest
 */
export type DriverOnShiftListRequest = Message<"raccoonai.DriverOnShiftListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: required raccoonai.DateTimeFilter date_time_filter = 2 [json_name = "date_time_filter"];
   */
  dateTimeFilter?: DateTimeFilter;

  /**
   * @generated from field: repeated raccoonai.DriverOnShiftStatus statuses = 3;
   */
  statuses: DriverOnShiftStatus[];

  /**
   * Keep only shifts that served at least one job at one of these pickup
   * locations. Empty means no pickup-location narrowing.
   *
   * @generated from field: repeated uint64 pickup_location_ids = 4 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.DriverOnShiftListRequest
 */
export type DriverOnShiftListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: required raccoonai.DateTimeFilter date_time_filter = 2 [json_name = "date_time_filter"];
   */
  date_time_filter?: DateTimeFilterJson;

  /**
   * @generated from field: repeated raccoonai.DriverOnShiftStatus statuses = 3;
   */
  statuses?: DriverOnShiftStatusJson[];

  /**
   * Keep only shifts that served at least one job at one of these pickup
   * locations. Empty means no pickup-location narrowing.
   *
   * @generated from field: repeated uint64 pickup_location_ids = 4 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.DriverOnShiftListRequest.
 * Use `create(DriverOnShiftListRequestSchema)` to create a new message.
 */
export const DriverOnShiftListRequestSchema: GenMessage<DriverOnShiftListRequest, {jsonType: DriverOnShiftListRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift_service, 0);

/**
 * @generated from message raccoonai.DriverOnShiftExistsRequest
 */
export type DriverOnShiftExistsRequest = Message<"raccoonai.DriverOnShiftExistsRequest"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.DriverOnShiftExistsRequest
 */
export type DriverOnShiftExistsRequestJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.DriverOnShiftExistsRequest.
 * Use `create(DriverOnShiftExistsRequestSchema)` to create a new message.
 */
export const DriverOnShiftExistsRequestSchema: GenMessage<DriverOnShiftExistsRequest, {jsonType: DriverOnShiftExistsRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift_service, 1);

/**
 * @generated from message raccoonai.AddDriverToShiftRequest
 */
export type AddDriverToShiftRequest = Message<"raccoonai.AddDriverToShiftRequest"> & {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.AddDriverToShiftRequest
 */
export type AddDriverToShiftRequestJson = {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.AddDriverToShiftRequest.
 * Use `create(AddDriverToShiftRequestSchema)` to create a new message.
 */
export const AddDriverToShiftRequestSchema: GenMessage<AddDriverToShiftRequest, {jsonType: AddDriverToShiftRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift_service, 2);

/**
 * @generated from message raccoonai.ForceCompleteDriverOnShiftRequest
 */
export type ForceCompleteDriverOnShiftRequest = Message<"raccoonai.ForceCompleteDriverOnShiftRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * One of the shift-level incident types: TRUCK_BREAKDOWN, TRAFFIC_ACCIDENT,
   * LOADERS_UNWELL, DRIVER_UNWELL or OTHER.
   *
   * @generated from field: required raccoonai.DriverIncidentType reason = 3;
   */
  reason: DriverIncidentType;

  /**
   * Free text from the dispatcher; required when the reason is OTHER.
   *
   * @generated from field: optional string explanation = 4;
   */
  explanation: string;
};

/**
 * @generated from message raccoonai.ForceCompleteDriverOnShiftRequest
 */
export type ForceCompleteDriverOnShiftRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * One of the shift-level incident types: TRUCK_BREAKDOWN, TRAFFIC_ACCIDENT,
   * LOADERS_UNWELL, DRIVER_UNWELL or OTHER.
   *
   * @generated from field: required raccoonai.DriverIncidentType reason = 3;
   */
  reason?: DriverIncidentTypeJson;

  /**
   * Free text from the dispatcher; required when the reason is OTHER.
   *
   * @generated from field: optional string explanation = 4;
   */
  explanation?: string;
};

/**
 * Describes the message raccoonai.ForceCompleteDriverOnShiftRequest.
 * Use `create(ForceCompleteDriverOnShiftRequestSchema)` to create a new message.
 */
export const ForceCompleteDriverOnShiftRequestSchema: GenMessage<ForceCompleteDriverOnShiftRequest, {jsonType: ForceCompleteDriverOnShiftRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift_service, 3);

/**
 * @generated from service raccoonai.DriverOnShiftService
 */
export const DriverOnShiftService: GenService<{
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.ListDriverOnShift
   */
  listDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftListRequestSchema;
    output: typeof DriverOnShiftListSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.ListTruckDriverOnShifts
   */
  listTruckDriverOnShifts: {
    methodKind: "unary";
    input: typeof TruckDriverOnShiftListRequestSchema;
    output: typeof TruckDriverOnShiftListSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.GetDriverOnShiftById
   */
  getDriverOnShiftById: {
    methodKind: "unary";
    input: typeof DriverOnShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.DeleteDriverOnShift
   */
  deleteDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.CreateDriverOnShift
   */
  createDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftCreateSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.UpdateDriverOnShift
   */
  updateDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftUpdateSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.CompleteDriverOnShift
   */
  completeDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.ForceCompleteDriverOnShift
   */
  forceCompleteDriverOnShift: {
    methodKind: "unary";
    input: typeof ForceCompleteDriverOnShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.CancelDriverOnShift
   */
  cancelDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.ApproveDriverOnShift
   */
  approveDriverOnShift: {
    methodKind: "unary";
    input: typeof DriverOnShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.DriverOnShiftExists
   */
  driverOnShiftExists: {
    methodKind: "unary";
    input: typeof DriverOnShiftExistsRequestSchema;
    output: typeof DriverOnShiftListSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverOnShiftService.AddDriverToShift
   */
  addDriverToShift: {
    methodKind: "unary";
    input: typeof AddDriverToShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_driver_on_shift_service, 0);

